export const formatVendorCount = vendorCount => {
  if (vendorCount < 1000) return vendorCount;

  return Math.floor(vendorCount / 100) * 100;
};
